// extracted by mini-css-extract-plugin
module.exports = {"base":"AdaptiveCardContent-module-base","bottomLeft":"AdaptiveCardContent-module-bottom-left","topLeft":"AdaptiveCardContent-module-top-left"};